import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})

export class XsAppConfigService {
  //public APLICACION_AMBIENTE: string = "localhost-nologin";
  public APLICACION_AMBIENTE: string = "localhost";
 //public APLICACION_AMBIENTE: string = "desarrollo-publico";
  // public APLICACION_AMBIENTE: string = "calidad";
  // public APLICACION_AMBIENTE: string = "produccion";

  public APLICACION_USUARIO_WINDOWS: string = "exsys";
  public APLICACION_ID_SESION: string = "";
  public APLICACION_PERFIL: string = "";
  public APLICACION_ID_EMPRESA = 4; //OEFA
  public APLICACION_ID_SISTEMA = 5; //PIA
  public ID_SUBSECTOR: string;
  public ID_USUARIO: string = '0';
  public APLICACION_NOMBRE = "SSO2";
  // Para evitar Alfresco.
  public ENTORNO: string = "dev"; // Equipos dentro de OEFA

  constructor() { }


  obtenerImagen(idPlugin) {
    switch (idPlugin) {
      case 11:
        return "assets/images/bandeja.png";
      case 12:
        return "assets/images/usuarios_secundarios.png";
      case 0:
        return "assets/images/casillas_electronicas.png";
      case 1:
        return "assets/images/mesa_partes.png";
      case 2:
        return "assets/images/expediente_virtual.png";
      case 3:
        return "assets/images/reporte_emergencias.png";
      case 4:
        return "assets/images/documents_64.png";
      case 5:
        return "assets/images/apr.png";
      case 6:
        return "assets/images/acceso_informacion.png";
      case 7:
        return "assets/images/quejas_reclamos.png";
      case 8:
        return "assets/images/other_64.png";
      default:
        return "assets/images/default_64.png";
    }
  }
}
